// Функция для передачи в filterOption компонента Select. !!!Работает только для Select с параметром options
export const selectFilterOption = (input, option) =>
  (option?.label ?? "").toLowerCase().includes(input.toLowerCase().trim());

// Функция для передачи в filterOption компонента Select. !!!Работает только для Select с Select.Option
export const selectFilterOptionWithChildren = (input: string, option: any) => {
  const children = option?.children;
  if (typeof children === "object") {
    return children.props.children.toLowerCase().includes(input.toLowerCase());
  }
  if (typeof children === "string") {
    return children.toLowerCase().includes(input.toLowerCase());
  }
  return true;
};
